import React, {useState} from 'react'
import Plot from 'react-plotly.js'
import {Select} from 'antd'
import {TextCenter} from 'react-bootstrap-icons'

const {Option} = Select

const StreamgraphChart2 = () => {
  const [data, setData] = useState(generateRandomData(20))

  // Sample data
  function generateRandomData(numWeeks: number): {
    x_data: string[]
    y_data1: number[]
    y_data2: number[]
    y_data3: number[]
    y_data4: number[]
  } {
    const x_data: string[] = []
    const y_data1: number[] = []
    const y_data2: number[] = []
    const y_data3: number[] = []
    const y_data4: number[] = []

    for (let i = 1; i <= numWeeks; i++) {
      x_data.push(`Week${i}`)
      y_data1.push(Math.floor(Math.random() * 10) + 1) // Random number between 1 and 10
      y_data2.push(Math.floor(Math.random() * 5)) // Random number between 0 and 4
      y_data3.push(Math.floor(Math.random() * 10) + 1) // Random number between 1 and 10
      y_data4.push(Math.floor(Math.random() * 1000) + 1) // Random number between 1 and 10
    }

    return {x_data, y_data1, y_data2, y_data3, y_data4}
  }

  const trace3 = {
    x: data.x_data,
    y: data.y_data3,
    type: 'bar',
    marker: {color: '#DBDFE9'},
    name: 'Total Visits',
  }

  const trace4 = {
    x: data.x_data,
    y: data.y_data4,
    yaxis: 'y2',
    type: 'scatter',
    mode: 'lines',
    line: {color: '#203879'},
    name: '#Visits for respiratory syndromes',
  }

  const plotData = [trace4, trace3]

  const layout = {
    title: 'Emergency room visits for respiratory syndromes (France - Lyon)',
    barmode: 'stack',
    bargap: 0.2, // Adjust the gap between bars
    bargroupgap: 0.1, // Adjust the gap between bar groups
    autosize: true,

    xaxis: {
      title: 'Weeks',
      autorange: true,
      type: 'category',
    },
    yaxis: {
      title: '#',
      autorange: true,
    },
    yaxis2: {
      title: '%',
      showgrid: false,
      titlefont: {color: 'rgb(148, 103, 189)'},
      tickfont: {color: 'rgb(148, 103, 189)'},
      overlaying: 'y',
      side: 'right',
    },
    legend: {
      x: 0,
      y: -0.2, // Adjust the value to position the legend as per your requirement
      orientation: 'h', // 'h' for horizontal, 'v' for vertical
    },
  }

  function handleDataChange(value) {
    if (value === 'Covid') {
      setData(generateRandomData(20)) // Change to your actual data
    } else if (value === 'Influenza') {
      setData(generateRandomData(20)) // Change to your actual data
    } else {
      setData(generateRandomData(20)) // Change to your actual data
    }
  }
  const [selectedValues, setSelectedValues] = useState<string[]>(['1', '2', '3', '4', '5', '6'])

  const handleDataChange2 = (selected) => {
    if (selected.includes('7')) {
      setSelectedValues(['1', '2', '3', '4', '5', '6'])
    } else {
      setSelectedValues(selected)
    }
  }

  return (
    <>
      <div className='row'>
        <label style={{width: '10%'}} className='col-1 mt-3 text-primary fw-medium fs-5'>
          Age group :
        </label>
        <div className='col-6'>
          <Select
            variant='borderless'
            className='border border-gray-500 border-3 rounded'
            style={{width: '71%'}}
            size='large'
            value={selectedValues}
            onChange={handleDataChange2}
            mode='multiple'
          >
            <Option key={'1'} value={'1'}>
              {'1<'}
            </Option>
            <Option key={'2'} value={'2'}>
              {'1 à 4'}
            </Option>
            <Option key={'3'} value={'3'}>
              {'5 à 19'}
            </Option>
            <Option key={'4'} value={'4'}>
              {'20 à 49'}
            </Option>
            <Option key={'5'} value={'5'}>
              {'50 à 64'}
            </Option>
            <Option key={'6'} value={'6'}>
              {'65+'}
            </Option>
            <Option key={'7'} value={'7'}>
              {'all ages'}
            </Option>
          </Select>
        </div>
      </div>
      <Plot
        style={{width: '100%', height: '400px'}}
        data={plotData}
        layout={layout}
        config={{
          displaylogo: false,
          responsive: true,
        }}
      />
    </>
  )
}

export default StreamgraphChart2
